import axios from "axios";

import { BASE_URL } from "../../../constant";
import {
    handleFormatResponse,
    handleFormatResponseForError,
} from "../../../utility";

export const useFlightMarkupsData = () => {
    const getFlightMarkupsData = async (url: string) => {
        try {
            let response = await axios.get(`${BASE_URL}flight/markups${url && url}`);
            const formattedResponse = handleFormatResponse(response);
            return formattedResponse;
        } catch (error: any) {
            const formattedError = handleFormatResponseForError(error);
            return formattedError;
        };
    };

    const postFlightMarkupsData = async (url: string, payload: any) => {
        try {
            let response;
            if (payload == null) {
                response = await axios.post(`${BASE_URL}flight/markups${url && url}`)
            } else {
                response = await axios.post(`${BASE_URL}flight/markups${url}`, payload)
            };
            const formattedResponse = handleFormatResponse(response);
            return formattedResponse;
        } catch (error: any) {
            const formattedError = handleFormatResponseForError(error);
            return formattedError;
        };
    };

    const putFlightMarkupsData = async (url: string, payload: any) => {
        try {
            let response = await axios.put(`${BASE_URL}flight/markups${url && url}`, payload);
            const formattedResponse = handleFormatResponse(response);
            return formattedResponse;
        } catch (error: any) {
            const formattedError = handleFormatResponseForError(error);
            return formattedError;
        };
    };

    const patchFlightMarkupsData = async (url: string, payload?: any) => {
        try {
            let response = await axios.patch(`${BASE_URL}flight/markups${url && url}`, payload && payload);
            const formattedResponse = handleFormatResponse(response);
            return formattedResponse;
        } catch (error: any) {
            const formattedError = handleFormatResponseForError(error);
            return formattedError;
        };
    };

    const deleteFlightMarkupsData = async (url: string) => {
        try {
            let response = await axios.delete(`${BASE_URL}flight/markups${url && url}`);
            const formattedResponse = handleFormatResponse(response);
            return formattedResponse;
        } catch (error: any) {
            const formattedError = handleFormatResponseForError(error);
            return formattedError;
        };
    };


    return {
        getFlightMarkupsData,
        postFlightMarkupsData,
        putFlightMarkupsData,
        patchFlightMarkupsData,
        deleteFlightMarkupsData
    };

};